import axios from 'axios'
import store from '@/store'
import Constants from '@/helpers/Constants'

/**
 * Broker for the DB-backed authentication service.
 *
 * Uses axios directly (not AxiosManager) so that auth-specific error handling
 * (e.g. a failed login returning 401) is not treated as a session timeout.
 */
export default class AuthBroker {

  private static authHeaders() {
    const token = store.getters.getAccessToken
    return { headers: { Authorization: 'Bearer ' + token } }
  }

  /**
   * Authenticate with username/password.
   *
   * @returns The login payload { token, username, permissions, must_change_password, ... }
   */
  public static async login(username: string, password: string): Promise<any> {
    const res = await axios.post(`${Constants.SERVER_URL}/login`, { username, password })
    return res.data.payload
  }

  /**
   * Revoke the current session on the server.
   */
  public static async logout(): Promise<void> {
    try {
      await axios.post(`${Constants.SERVER_URL}/logout`, {}, this.authHeaders())
    } catch (error) {
      // Best-effort; the client clears local state regardless.
    }
  }

  /**
   * Fetch the current user's identity and permissions.
   */
  public static async me(): Promise<any> {
    const res = await axios.get(`${Constants.SERVER_URL}/me`, this.authHeaders())
    return res.data.payload
  }

  /**
   * Change the current user's password.
   */
  public static async changePassword(currentPassword: string, newPassword: string): Promise<any> {
    const res = await axios.post(
      `${Constants.SERVER_URL}/change_password`,
      { current_password: currentPassword, new_password: newPassword },
      this.authHeaders()
    )
    return res.data
  }
}
